var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 4.5H3.5C3.30109 4.5 3.11032 4.57902 2.96967 4.71967C2.82902 4.86032 2.75 5.05109 2.75 5.25V18C2.75 18.3978 2.90804 18.7794 3.18934 19.0607C3.47064 19.342 3.85218 19.5 4.25 19.5H20.75C21.1478 19.5 21.5294 19.342 21.8107 19.0607C22.092 18.7794 22.25 18.3978 22.25 18V5.25C22.25 5.05109 22.171 4.86032 22.0303 4.71967C21.8897 4.57902 21.6989 4.5 21.5 4.5ZM20.75 18H4.25V6.95531L11.9928 14.0531C12.1312 14.1801 12.3122 14.2506 12.5 14.2506C12.6878 14.2506 12.8688 14.1801 13.0072 14.0531L20.75 6.95531V18Z",
    fill: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailEnvelope);
export default __webpack_public_path__ + "static/media/email-envelope.877173620126cdaa6a9cafebfab25194.svg";
export { ForwardRef as ReactComponent };